require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./klamath-county-jail-treatment.json") })
        }
      }, "path---klamath-county-jail-treatment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---klamath-county-jail-treatment!./.cache/json/klamath-county-jail-treatment.json
// module id = 917
// module chunks = 231608221292675